import { process, State } from '@progress/kendo-data-query';
import { GridDataStateChangeEvent, GridDetailRowProps } from '@progress/kendo-react-grid';
import { GridSelectableSettings } from '@progress/kendo-react-grid/dist/npm/interfaces/GridSelectableSettings';
import { FC, useCallback, useState } from 'react';
import { useAccrualChildColumns } from 'src/assets/static/accrual-report/useAccrualColumn';
import GridWrapper from 'src/components/GridWrapper';
import AccrualSubChild from './AccrualSubChild';

const selectable: GridSelectableSettings = {
  enabled: false,
  drag: false,
  cell: false,
};

const defaultProps = {
  tableTextId: 'GL Codes',
  DataItemKey: 'rowId',
  sortable: true,
  resizable: true,
  showColumnMenu: true,
  selectable: selectable,
  pageable: false,
} as const;

const AccrualChild: FC<GridDetailRowProps> = (props) => {
  const [state, setState] = useState<State>({ skip: 0 });
  const handleDataStateChange = useCallback((e: GridDataStateChangeEvent) => {
    setState(e.dataState);
  }, []);

  const { data, total } = process(props.dataItem.pos, state);
  const columns = useAccrualChildColumns(props.dataItem.glCd);

  return (
    <main className="mt-2">
      <GridWrapper
        id="AccrualChild"
        detail={AccrualSubChild}
        columns={columns}
        dataSource={data}
        total={total}
        {...defaultProps}
        noRecordText={'No records to display'}
        isCustomExpandableRow
        dataState={state}
        onDataStateChange={handleDataStateChange}
        className="no_Veritcal_ScrollBar"
        hideScrollBar
      />
    </main>
  );
};

export default AccrualChild;
